import React, { useState } from 'react';
import './TextSettingsSection.css';
import TextInputSection from './TextInputSection';

function TextSettingsSection({ 
    textConfig, 
    editData, 
    handleInputChange, 
    showFontSelector = false, 
    showTextEffects = false, 
    showButtonEffects = false 
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    
    return (
        <div className="revolutionary-text-container">
            {/* Sleek Header mit modernem Toggle */}
            <div 
                className={`text-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="text-header-content">
                    <div className="text-icon">
                        <i className="fa fa-font"></i>
                    </div>
                    <div className="text-title">Texts</div>
                    <div className="text-count">{textConfig.length}</div>
                </div>
                <div className={`text-toggle-arrow ${isExpanded ? 'rotated' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content - Flat Design */}
            {isExpanded && (
                <div className="text-content-expanded">
                    <TextInputSection 
                        textConfig={textConfig}
                        editData={editData}
                        handleInputChange={handleInputChange}
                        showFontSelector={showFontSelector}
                        showTextEffects={showTextEffects}
                        showButtonEffects={showButtonEffects}
                    />
                </div>
            )}
        </div>
    );
}

export default TextSettingsSection;